import { MatchDetailPage } from "@/features/match/pages/MatchDetail";

const MatchDetail = () => {
  return <MatchDetailPage />;
};

export default MatchDetail;
